import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Col, Row, Button } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import DetailedSurchargesTable from './DetailedSurchargesTable';
import DetailedSurchargesPDF from './DetailedSurchargesPDF';
import DetailedSurchargesExcel from './DetailedSurchargesExcel';

const DetailedSurcharges = ({ opened, closeModal, data, numFacTer }) => {

    const [showPDF, setShowPDF] = useState(false);

    const exportPdfDetailedSurcharges = async () => {
        setShowPDF(true);
        let clinica = JSON.parse(sessionStorage.getItem('clinica'));
        let obj = {
            items: data,
            profile: clinica,
            title: "Detalles de Recargos"
        }
        await DetailedSurchargesPDF(obj, numFacTer);
    }

    const exportExcelDetailedSurcharges = async () => {
        await DetailedSurchargesExcel.exportExcel(data);
    }

    useEffect(() => {
    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Detalle de Recargos</h5>
                        </div>

                        {data != null && data != undefined ?
                            <Row>
                                <Col md={12}>
                                    <DetailedSurchargesTable reactTableData={data} />
                                </Col>
                            </Row> : null}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-danger btn-sm text-white"
                            onClick={() => {
                                exportPdfDetailedSurcharges();
                            }}
                        >
                            <FontAwesomeIcon icon={faFilePdf} /> Exportar a PDF
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-success btn-sm text-white"
                            onClick={() => {
                                exportExcelDetailedSurcharges();
                            }}
                        >
                            <FontAwesomeIcon icon={faFileExcel} /> Exportar a Excel
                        </Button>

                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showPDF}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <IconButton style={{ float: 'right' }} onClick={() => {
                        setShowPDF(false);
                    }}>
                        <CloseIcon />
                    </IconButton>
                    <iframe id="pdfV" width="1000" height="700" >
                    </iframe>
                </div>
            </Modal>


        </div>
    );
};
export default DetailedSurcharges;
